import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AuthUser } from '../api/auth'
import { teardownSip } from '../lib/sip'
import { queryClient } from '../main'

interface AuthState {
  user: AuthUser | null
  accessToken: string | null
  setAuth: (user: AuthUser, token: string) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      setAuth: (user, token) => {
        localStorage.setItem('access_token', token)
        queryClient.clear()
        set({ user, accessToken: token })
      },
      clearAuth: () => {
        localStorage.removeItem('access_token')
        teardownSip()
        queryClient.clear()
        set({ user: null, accessToken: null })
      },
    }),
    {
      name: 'crm-auth',
      partialize: (state) => ({ user: state.user }),
    },
  ),
)
